export default "assets/images/icons/facebook-eb0354bf.svg";